/* EPIC CLOTHING — motion layer.
   Scroll reveals, marquee duplication, header state. No dependencies. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------- scroll reveals */
  function initReveals(root) {
    var nodes = (root || document).querySelectorAll(
      '[data-epic-reveal]:not(.epic-bound), [data-epic-mask]:not(.epic-bound), [data-epic-line]:not(.epic-bound)'
    );
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in', 'epic-bound'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (n) {
      n.classList.add('epic-bound');
      io.observe(n);
    });
  }

  /* ---------------------------------------------------- marquee cloning */
  function initMarquees(root) {
    var tracks = (root || document).querySelectorAll('[data-epic-marquee]:not(.epic-bound)');
    tracks.forEach(function (track) {
      track.classList.add('epic-bound');
      var group = track.firstElementChild;
      if (!group) return;
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 12) {
        track.appendChild(group.cloneNode(true));
        guard++;
      }
      var half = track.innerHTML;
      track.innerHTML = half + half;
      var speed = parseFloat(track.getAttribute('data-speed') || '30');
      track.style.animationDuration = speed + 's';
    });
  }

  /* ---------------------------------------------------- header state */
  function initHeaderState() {
    var last = -1;
    function onScroll() {
      var y = window.scrollY > 8;
      if (y === last) return;
      last = y;
      document.body.classList.toggle('epic-scrolled', y);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------- hero stagger */
  function initHero(root) {
    var chars = (root || document).querySelectorAll('.epic-hero__char:not(.epic-bound)');
    chars.forEach(function (c, i) {
      c.classList.add('epic-bound');
      var span = c.firstElementChild;
      if (span) span.style.setProperty('--epic-delay', 90 + i * 95 + 'ms');
    });
  }

  /* ---------------------------------------------------- stagger helper */
  function initStagger(root) {
    var groups = (root || document).querySelectorAll('[data-epic-stagger]:not(.epic-bound)');
    groups.forEach(function (g) {
      g.classList.add('epic-bound');
      var step = parseInt(g.getAttribute('data-epic-stagger'), 10) || 90;
      Array.prototype.forEach.call(g.children, function (child, i) {
        child.style.setProperty('--epic-delay', i * step + 'ms');
      });
    });
  }

  function boot(root) {
    initStagger(root);
    initHero(root);
    initMarquees(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); initHeaderState(); });
  } else {
    boot(document);
    initHeaderState();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
